// assets/cw-installment-calc.js

if (!customElements.get('cw-installment-calculator')) {
  class CwInstallmentCalculator extends HTMLElement {
    constructor() {
      super();
      this.priceInCents = parseInt(this.dataset.initialPrice, 10) || 0;
      this.interestRates = this.getInterestRates();
      this.defaultInstallments = parseInt(this.dataset.defaultInstallments, 10) || 1;
      this.currentInstallments = this.defaultInstallments;
      this.installmentCountElement = this.querySelector('[data-installment-count]');
      this.installmentValueElement = this.querySelector('[data-installment-value]');
      this.selector = this.querySelector('select');
      this.productHandle = this.dataset.productHandle || null;
      this._lastUrl = window.location.href;
      this._urlChangeDebounce = null;
    }

connectedCallback() {
  if (this.selector) {
    this.selector.addEventListener('change', (e) => {
      this.currentInstallments = parseInt(e.target.value, 10);
      this.updateInstallmentDisplay();
    });
  }

  // Detecta se é o produto principal da página
  const currentPath = window.location.pathname;
  const isMainProductPage =
    currentPath.includes(`/products/${this.dataset.productHandle}`) &&
    document.querySelector('form[action*="/cart/add"]');

  // Detecta se é um card (produto em lista ou recomendado)
  const isInsideCard = this.closest('.product-card, .card, .grid-product, .product-grid-item, .cw-installment-wrapper');

  if (isMainProductPage && !isInsideCard) {
    // Produto principal → escuta variante e URL
    this.initVariantListenerForProductPage();
  } else {
    // Cards (homepage, coleção, recomendados)
    this.initPriceObserverForCard();
  }

  // Atualiza inicialmente
  this.updateInstallmentDisplay();
}


   initPriceObserverForCard() {
  // Tenta encontrar o preço no card (suporte para vários layouts)
  const priceElement =
    this.closest('.product-card, .card, .grid-product, .product-grid-item, .cw-installment-wrapper')
      ?.querySelector('.price, .price-item--regular, .price__regular, [data-price], [data-product-price]');

  if (!priceElement) return;

  const handlePriceChange = () => {
    const newPrice = this.parsePriceToCents(priceElement.textContent || '');
    if (newPrice > 0 && newPrice !== this.priceInCents) {
      this.priceInCents = newPrice;
      this.updateInstallmentDisplay();
    }
  };

  // Observa alterações no texto do preço
  const observer = new MutationObserver(handlePriceChange);
  observer.observe(priceElement, { childList: true, subtree: true, characterData: true });

  // Força atualização inicial
  handlePriceChange();
}


    initVariantListenerForProductPage() {
      // 1) Escuta evento do tema (se houver)
      document.body.addEventListener('variant:change', (event) => {
        try {
          if (event.detail?.variant?.price) {
            this.priceInCents = parseInt(event.detail.variant.price, 10);
            this.updateInstallmentDisplay();
          }
        } catch (e) { /* ignore */ }
      });

      // 2) Escuta mudanças no DOM que podem indicar navegação por AJAX
      const bodyObserver = new MutationObserver(() => {
        this._onPotentialUrlChange();
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });

      // 3) Intercepta pushState/replaceState para detectar navegações SPA
      this._patchHistoryMethods();

      // 4) Escuta popstate
      window.addEventListener('popstate', () => this._onPotentialUrlChange());

      // 5) Se o produto handle foi fornecido, tenta obter a variante atual ao carregar
      if (this.productHandle) {
        // small delay para garantir que o tema tenha feito atualizações iniciais
        setTimeout(() => this.updatePriceFromCurrentVariant(), 250);
      }
    }

    _onPotentialUrlChange() {
      if (this._lastUrl === window.location.href) return;
      // debounce para agrupar múltiplas mutações rápidas
      this._lastUrl = window.location.href;
      clearTimeout(this._urlChangeDebounce);
      this._urlChangeDebounce = setTimeout(() => {
        this.updatePriceFromCurrentVariant();
      }, 120);
    }

    _patchHistoryMethods() {
      if (this._historyPatched) return;
      const wrap = (method) => {
        const original = history[method];
        history[method] = function () {
          const ret = original.apply(this, arguments);
          window.dispatchEvent(new Event(method));
          window.dispatchEvent(new Event('locationchange'));
          return ret;
        };
      };
      wrap('pushState');
      wrap('replaceState');
      // também escuta um custom event
      window.addEventListener('locationchange', () => this._onPotentialUrlChange());
      this._historyPatched = true;
    }

    async updatePriceFromCurrentVariant() {
      // 1) tenta extrair variant id da URL (?variant=123) ou do input[name="id"]
      const variantId = this._extractVariantIdFromUrl() || this._extractVariantIdFromInputs();

      // 2) se tiver variantId e productHandle, tenta buscar `/products/<handle>.js`
      if (this.productHandle) {
        try {
          const productJson = await fetch(`/products/${this.productHandle}.js`, { cache: 'no-cache' }).then(r => r.json());
          if (productJson && productJson.variants && productJson.variants.length) {
            let foundVariant = null;
            if (variantId) {
              foundVariant = productJson.variants.find(v => String(v.id) === String(variantId));
            }
            if (!foundVariant) {
              // tenta usar selected_or_first_available (fall back)
              foundVariant = productJson.variants.find(v => v.available) || productJson.variants[0];
            }
            if (foundVariant && foundVariant.price != null) {
              // Em alguns temas price já vem em centavos (inteiro). Se vier decimal, tratamos também.
              const priceCents = Math.round(Number(foundVariant.price));
              if (priceCents > 0 && priceCents !== this.priceInCents) {
                this.priceInCents = priceCents;
                this.updateInstallmentDisplay();
                return;
              }
            }
          }
        } catch (err) {
          // falha ao buscar JSON do produto — segue para tentativa pelo DOM
          // console.warn('Erro ao buscar /products/<handle>.js', err);
        }
      }

      // 3) fallback: ler do DOM (várias tentativas de seletor)
      const priceEl = this._findPriceElementOnPage();
      if (priceEl) {
        const newPrice = this.parsePriceToCents(priceEl.innerText || priceEl.textContent || '');
        if (newPrice > 0 && newPrice !== this.priceInCents) {
          this.priceInCents = newPrice;
          this.updateInstallmentDisplay();
        }
      }
    }

    _extractVariantIdFromUrl() {
      try {
        const u = new URL(window.location.href);
        const v = u.searchParams.get('variant');
        if (v) return v;
      } catch (e) { /* ignore */ }
      // tenta extrair /?variant=123 ou /products/handle?variant=123 já coberto
      return null;
    }

    _extractVariantIdFromInputs() {
      // input[type=hidden][name=id] usado por muitos temas
      const input = document.querySelector('input[name="id"]') || document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (input && input.value) return input.value;
      // também verifica selects com name="id"
      const select = document.querySelector('select[name="id"]');
      if (select && select.value) return select.value;
      return null;
    }

    _findPriceElementOnPage() {
      // Lista de seletores comuns (adapte se seu tema usa outro)
      const selectors = [
        '[data-price] [data-price-item="regular"]',
        '.price-item--regular',
        '[data-product-price]',
        '.price--current',
        '.price',
        '.product__price',
        '[data-current-price]',
        '.price-item'
      ];
      for (const s of selectors) {
        const el = document.querySelector(s);
        if (el && el.offsetParent !== null) return el;
      }
      // se nada, tenta encontrar qualquer elemento com símbolo R$
      const maybe = Array.from(document.querySelectorAll('span,div')).find(n => /R\$\s*\d/.test(n.textContent || ''));
      return maybe || null;
    }

    getInterestRates() {
      const settings = JSON.parse(this.dataset.interestrates || this.dataset.interestRates || '{}' );
      const rates = {};
      for (let i = 2; i <= 12; i++) {
        rates[i] = settings[`interest_${i}x`] || '0';
      }
      return rates;
    }

    parsePriceToCents(priceString) {
      if (!priceString || typeof priceString !== 'string') return 0;
      // Remove R$, espaços e pontos; troca vírgula por ponto
      const cleaned = priceString.replace(/R\$\s?/g, '').replace(/\s/g, '').replace(/\./g, '').replace(',', '.');
      const num = parseFloat(cleaned);
      if (isNaN(num)) return 0;
      return Math.round(num * 100);
    }

    calculateInstallmentValue() {
      if (this.priceInCents === 0 || !this.currentInstallments) return 0;
      const priceInReais = this.priceInCents / 100;
      const interestRate = parseFloat(this.interestRates[this.currentInstallments] || '0');
      const totalAmount = priceInReais * (1 + interestRate / 100);
      return totalAmount / this.currentInstallments;
    }

    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
    }

    updateInstallmentDisplay() {
      const installmentValue = this.calculateInstallmentValue();
      if (this.installmentCountElement) {
        this.installmentCountElement.textContent = this.currentInstallments;
      }
      if (this.installmentValueElement) {
        this.installmentValueElement.textContent = this.formatCurrency(installmentValue);
      }
    }
  }

  customElements.define('cw-installment-calculator', CwInstallmentCalculator);
}
